<template>
  <li class="bbs">
    <router-link :to="'/broadcast/' + idx">
      <p class="title">
        {{ title }}
        <slot name="refresh" />
      </p>
      <p>
        <span class="date" v-if="idx !== 'notice'">
          <b>{{ uploadAt.format("LLL") }}</b>
          ({{ uploadAt.fromNow() }})
        </span>
        <span class="date" v-else>공지 사항</span>
      </p>
      <i class="arrow right" />
    </router-link>
  </li>
</template>
<script>
export default {
  name: "DashboardCard",
  props: ["idx", "title", "contents", "reads", "author", "uploadAt"]
};
</script>
